module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc6-7732f3bed7f690a55a1492b7bbd3cbfd.jpg";